const video = {
	state: {
		vcr: {
			vcrList: [],
			vcrSonList: []
		},
		ysyone: {
			rtmp: null,
			liveAddress: null,
			rtmpHd: null,
			hdAddress: null,
		},
		ysylist: {
			list: null,
			page: {
				total: 0
			}
		},
		ysyphoto: null
	},
	mutations: {
		vcr(state,value)
		{
			state.vcr=value;
		},
		ysyone(state,value)
		{
			state.ysyone=value;
		},
		ysylist(state,value)
		{
			state.ysylist=value;
		},
		ysyphoto(state,value)
		{
			state.ysyphoto=value;
		}
	},
	actions: {
		
	},
	getters: {
		fullmenu: state=>{
			let menu = state.vcr.vcrList.map(value=>{
				return{
					id: value.id,
					name: value.name,
					icon: "my-icon-luxiangji",
					link: "fullview",
					select: false,
					submenu: []
				}
			})
			if(state.vcr.vcrSonList.length>0)
			{
				menu.push({
					id: 0,
					name: "子设备",
					icon: "my-icon-shxt",
					link: "fullview",
					select: false,
					submenu: []
				})
			}
			return menu;
		},
		dwvideo: state=>{
			let values=state.vcr.vcrList;
			if(state.vcr.vcrSonList.length>0)
			{
				values.push({
					id: 0,
					name: "子设备",
					videoList: state.vcr.vcrSonList.map(value=>{
						if(value.videoList.length>0)
						{
							return {
								id: value.videoList[0].id,
								name: value.videoList[0].name
							}
						}
					})
				});
			}
			return values;
		}
	}
};
export default {
	namespaced: true,
	video
};
